import type { ScheduleSummary } from '../../types';
import { getNextFireTime } from '../../utils/useCountdown';
import ConfiguredMessageRow from './ConfiguredMessageRow';

interface ConfiguredMessagesListProps {
    vin: string;
    schedules: ScheduleSummary[];
    onViewConfig: (schedule: ScheduleSummary) => void;
    onOpenInArbitrary: (schedule: ScheduleSummary, mergedJson: string, overriddenJsonPaths: string[]) => void;
}

const ConfiguredMessagesList = ({ vin, schedules, onViewConfig, onOpenInArbitrary }: ConfiguredMessagesListProps) => {
    const nearestIndex =
        schedules
            .map((s) => ({ index: s.index, next: getNextFireTime(s.cron) }))
            .filter((x): x is { index: number; next: number } => x.next !== null)
            .sort((a, b) => a.next - b.next)[0]?.index ?? null;

    return (
        <div>
            {schedules.map((schedule) => (
                <ConfiguredMessageRow
                    key={schedule.index}
                    vin={vin}
                    schedule={schedule}
                    onViewConfig={onViewConfig}
                    onOpenInArbitrary={onOpenInArbitrary}
                    isNearest={schedule.index === nearestIndex}
                />
            ))}
        </div>
    );
};

export default ConfiguredMessagesList;
